import { CountUp } from "countup.js";
const initStatistics = (section) => {
    const numbers = section.querySelectorAll(".number");
    numbers.forEach((el) => {
        const rawText = el.textContent.trim();
        // Remove anything not part of a number
        const cleanValue = rawText.replace(/[^0-9.-]/g, "");
        const endVal = parseFloat(cleanValue);
        if (isNaN(endVal))
            return;
        // Detect exact decimal places
        let decimalPlaces = 0;
        const decimalMatch = cleanValue.match(/\.(\d+)/);
        if (decimalMatch) {
            decimalPlaces = decimalMatch[1].length;
        }
        // Reset before animation
        el.textContent = "0";
        const countUp = new CountUp(el, endVal, {
            duration: 2,
            decimalPlaces: decimalPlaces,
            separator: ",",
        });
        if (!countUp.error) {
            countUp.start();
        }
        else {
            console.error(countUp.error);
        }
    });
};
// Run on scroll
const sections = document.querySelectorAll(".statistics");
const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            initStatistics(entry.target);
            obs.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.3,
});
sections.forEach((section) => {
    observer.observe(section);
});
